module.exports = __webpack_public_path__ + "img/ch8.aa9186c9.jpg";